import api from 'api';
import ApiService from 'api/ApiService';
import {dispatchAsync} from 'redux/common';
import {DialogCallbacks} from 'types/common';
import {IVFSPathRequestParams} from 'types/diplomat/sftp/VFSNode';
import types from './types';

const moveSftpUser = (userIds: string[], folderId: string, cbs?: DialogCallbacks) =>
   dispatchAsync(api.sftpUserMove, types.MOVE_SFTP_USER, {
      ...cbs,
      getMethod: ApiService.postSecureJson,
      data: {
         userIds,
         folderId,
      },
   });

const moveSftpGroup = (groupIds: string[], folderId: string, cbs?: DialogCallbacks) =>
   dispatchAsync(api.vfsgroupsMove, types.MOVE_SFTP_GROUP, {
      ...cbs,
      getMethod: ApiService.postSecureJson,
      data: {
         groupIds,
         folderId,
      },
   });

const expandVFSNode = (data: IVFSPathRequestParams, cbs?: DialogCallbacks) => {
   return dispatchAsync(api.vfsExpand, types.EXPAND_VFS_NODE, {
      ...cbs,
      getMethod: ApiService.postSecureJson,
      data,
      useReqDataOnSuccess: true,
   });
};

const getRefsSsh = (id: string, cbs?: DialogCallbacks) =>
   dispatchAsync(`${api.sftpRefsSsh}/${id}`, types.GET_REFS_SSH, {
      ...cbs,
   });

export default {
   moveSftpUser,
   moveSftpGroup,
   expandVFSNode,
   getRefsSsh,
};
